/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import {
  Grid,
  VirtualizedCell,
  defaultVirtualizedCellRender,
  extractAndFormatData,
  virtualizedGridRenderer,
  freeEditEngine,
  toSelectionColProps,
} from '@integec/grid-tools'
import {
  Button,
  Checkbox,
  DatePicker,
  Divider,
  Input,
  Popconfirm,
  Select,
  Tooltip,
  message,
  Icon,
} from 'antd'
import { ErrorContext, JcTmpErrorContext, SpinContext } from 'context'
import { getApiTargetInfo, getPermitActions } from 'core'
import R from 'ramda'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Label,
  Title,
} from 'core/screen-util'
import React, {
  useEffect,
  useState,
  useContext,
  useMemo,
  useCallback,
} from 'react'
import { connect } from 'react-redux'
import {
  SolarStorageInverterEventIoHeaders,
  SolarStorageInverterPerformanceHeaders,
} from './Headers'
import { rowHeaderRender, hasAccesPermits } from 'core/utils'
import moment from 'moment'
import {
  getSolarStorageData,
  getSolarEventTypes,
  getSolarStorageGroupByYearMonth,
  getSolarStorageInverterGroupFormationByPlantandStorage,
  solarStorageInvEventDeleteInverter,
  solarStorageImpactAnalysis,
  solarStorageProcessEventAndPerformanceData,
  createSolarStorageInvPerormanceWithInvEvents,
  solarStorageInvEventUpdateInverter,
} from './solarapi'
import SolarInverterValidationDialog from './SolarInverterValidationDialog'
import {
  SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN,
  SOLAR_ADMIN_POWER_DATA,
} from 'core/EventActions'
import SolarInverterPerformanceDialog from './SolarInverterPerformanceDialog'
import {
  getSolarAvailabilityStatus,
  getSolarCauseCode,
  getSolarContribCondtition,
  getSolarInverterGroup,
  getSolarStorageGroup,
  solarEventUpdateInverter,
  solarPlantSelection,
  // solarProcessPerformanceData,
  // solarPlantWithStorageGroup,
} from 'api/pgads'
import { saveDateformat } from './SolarEventDialog'
import { getTimeZone } from 'wind2/wind2utils'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import SolarStoragePerformanceDialog from './SolarStoragePerformanceDialog'
import SolarInverterEventDialog from './SolarInverterEventDialog'
import ImpactAnalysisModal from './impactanalysis/ImpactAnalysis'
import SolarStorageInverterPerformanceDialog from './SolarStorageInverterPerformanceDialog'
import { intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import {
  getStoragePlantListNercReportingAllowing,
  getStoragePlantListNercReportingAllowingNot,
} from './util'

const StoragePowerData = ({
  targetInfo,
  actionPermits,
  isStandalone = false,
}) => {
  const [plantList, setPlantList] = useState([])
  const [storagePlantList, setStoragePlantList] = useState([])
  const [plantSelected, setPlantSelected] = useState()
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [isPerformacneSelected, setIsPerformacneSelected] = useState('SNP') //  SNP-nerc Perf , SIP - inv Perf , SIE - Inv.Event

  const [storageNercPerformanceData, setNercStoragePerformanceData] = useState(
    []
  )
  const [
    storageInverterPerformanceData,
    setStorageInverterPerformanceData,
  ] = useState([])
  const [storageInverterEventData, setStorageInverterEventData] = useState([])

  const [
    storageInverterPerformanceRowSelected,
    setStorageInverterPerformanceRowSelected,
  ] = useState([])

  const [
    storageNercPerformanceRowSelected,
    setStorageNercPerformanceRowSelected,
  ] = useState([])
  const [storageInverterRowSelected, setStorageInverterRowSelected] = useState(
    []
  )

  const [
    showStorageInverterPerformanceDialog,
    setShowStorageInverterPerformanceDialog,
  ] = useState({})
  const [
    showStorageNercPerformanceDialog,
    setStorageNercPerformanceDialog,
  ] = useState({})
  const [
    showStorageInverterEventDialog,
    setStorageInverterEventDialog,
  ] = useState({})

  const [selectedDate, setSelectedDate] = useState(
    moment()
      .subtract(1, 'months')
      .endOf('month')
  )
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const [showValidationDialog, setShowValidationDialog] = useState({})

  const [isRetrived, setIsRetrieved] = useState(false)
  const handleIsPerformacneSelected = value => {
    if (storageInverterEventEditInfo.updated.length > 0) {
      setShowValidationDialog({
        visible: true,
        value: value, // passing the value to the modal
        onYes: updateData, // function to call when "Yes" is clicked
        onNo: () => setIsPerformacneSelected(value), // correctly passing value to onNo handler
      })
    } else {
      setIsPerformacneSelected(value) // directly setting the value if no updates
    }
  }

  const hasSolarPowerDataWritePermission = useMemo(
    _ => {
      if (isStandalone)
        return hasAccesPermits({
          actionPermits: actionPermits,
          eventActions: [SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN],
          matchAny: true,
        })
      else
        return hasAccesPermits({
          actionPermits: actionPermits,
          eventActions: [SOLAR_ADMIN_POWER_DATA],
          matchAny: true,
        })
    },
    [actionPermits, isStandalone]
  )

  const clearData = _ => {
    setStorageInverterPerformanceData([])
    setNercStoragePerformanceData([])
    setStorageInverterEventData([])

    setStorageNercPerformanceRowSelected([])
    setStorageInverterRowSelected([])
    setStorageInverterRowSelected([])

    setStorageInverterEventEditInfo(freeEditEngine.generateInitialEditInfo())

    setIsRetrieved(false)
    setStorageInverterEventData([])
    // setRunInfoStatus({ isModificationExits: false })
    // setEventSelected([])
    // setImpactAnalysisDialog(false)
    // setImpactAnalysisData({})
  }

  const isPlantLocked = useMemo(
    _ => {
      const total = (storageNercPerformanceData || []).find(
        s => s.storageGroupId === 'TOTAL'
      ) || { action: 'U' }
      return total.action === 'L' || total.action === 'l'
    },
    [storageNercPerformanceData]
  )

  const [availableStatus, setAvailableStatus] = useState([])
  const [contribConditionList, setContribConditionList] = useState([])
  const [eventTypes, setEventTypes] = useState([])
  const [causecodeList, setCausecodeList] = useState([])
  const [storageGroupList, setStorageGroupList] = useState([])
  const storageGroupNameMap = useMemo(
    _ => {
      return R.compose(
        R.fromPairs,
        R.map(({ plantId, storageGroupId, storageGroupName }) => [
          plantId + '-' + storageGroupId,
          storageGroupName,
        ])
      )(storageGroupList)
    },
    [storageGroupList]
  )

  const [
    storageInverterEventEditInfo,
    setStorageInverterEventEditInfo,
  ] = useState(freeEditEngine.generateInitialEditInfo())

  const [inverterIdBYPlant, setInverterIdByPlant] = useState([])
  const [inverterGroupList, setInverterGroupList] = useState([])

  useEffect(
    _ => {
      solarPlantSelection(targetInfo)({
        year: selectedDate.format('YYYY'),
        month: selectedDate.format('MM'),
      }).fork(setError, data => {
        setPlantList(data)
      })
    },
    [targetInfo, selectedDate, setError, plantSelected]
  )

  useEffect(
    _ => {
      let stoList = []
      if (isStandalone) {
        stoList = getStoragePlantListNercReportingAllowingNot(
          plantList,
          inverterGroupList,
          storageGroupList
        )
      } else {
        stoList = getStoragePlantListNercReportingAllowing(
          plantList,
          inverterGroupList,
          storageGroupList
        )
      }

      setStoragePlantList(stoList)

      if (!plantSelected && stoList[0] && stoList[0].plantId)
        setPlantSelected(stoList[0].plantId)
    },
    [
      inverterGroupList,
      isStandalone,
      plantList,
      plantSelected,
      storageGroupList,
    ]
  )

  useEffect(
    _ => {
      getSolarContribCondtition(targetInfo).fork(
        _ => _,
        setContribConditionList
      )
      getSolarEventTypes(targetInfo).fork(_ => _, setEventTypes)
      getSolarAvailabilityStatus(targetInfo).fork(_ => _, setAvailableStatus)
      getSolarCauseCode(targetInfo).fork(
        _ => _,
        data => {
          const matchToSelct = data.map(
            ({ system, subsystem, causecode, description }) => ({
              system,
              component: subsystem,
              causeCode: causecode,
              description,
              unitCode: 'SO',
              unitType: 'SO',
              isOMC: false,
            })
          )
          setCausecodeList(matchToSelct)
        }
      )
      getSolarInverterGroup(targetInfo).fork(setError, setInverterGroupList)
      getSolarStorageGroup(targetInfo).fork(_ => _, setStorageGroupList)
      getSolarStorageInverterGroupFormationByPlantandStorage(targetInfo).fork(
        setError,
        setInverterIdByPlant
      )
    },
    [setError, targetInfo]
  )

  const StorageInverterPerformanceHeaderFormater = useMemo(
    _ => {
      return SolarStorageInverterPerformanceHeaders.map(d => {
        if (d.ident === 'inverterAvailability') {
          const statusMap = R.compose(
            R.fromPairs,
            R.map(d => [d.availabilityStatusCode, d.availabilityStatusName])
          )(availableStatus)
          return { ...d, ...toSelectionColProps(statusMap) }
        }
        if (d.ident === 'storageGroupId') {
          return {
            ...d,
            dataFormatter: ({ value, rowData }) => {
              return (
                value +
                ' - ' +
                storageGroupNameMap[rowData.plantId + '-' + value]
              )
            },
          }
        }
        return d
      })
    },
    [availableStatus, storageGroupNameMap]
  )

  const StorageNercPerformanceHeaderFormater = useMemo(
    _ => {
      return SolarStoragePerformanceIoHeaders.map(d => {
        if (d.ident === 'invGroupAvailability') {
          const statusMap = R.compose(
            R.fromPairs,
            R.map(d => [d.availabilityStatusCode, d.availabilityStatusName])
          )(availableStatus)
          return { ...d, ...toSelectionColProps(statusMap) }
        }
        if (d.ident === 'storageGroupId') {
          return {
            ...d,
            dataFormatter: ({ value, rowData }) => {
              if (value === 'TOTAL') return value
              return (
                value +
                ' - ' +
                storageGroupNameMap[rowData.plantId + '-' + value]
              )
            },
          }
        }
        return d
      })
    },
    [availableStatus, storageGroupNameMap]
  )

  const StorageInverterEventHeaders = useCallback(
    width =>
      SolarStorageInverterEventIoHeaders(
        width,
        contribConditionList,
        eventTypes,
        causecodeList
      ),
    [contribConditionList, eventTypes, causecodeList]
  )
  const isEditableComp = ({ header }) => {
    const { ident } = header
    // if (!isEditable) return false
    if (
      ident === 'modifier' ||
      ident === 'modifiedDate' ||
      ident === 'inverterId' ||
      ident === 'eventId'
    )
      return false
    return true
  }

  const editRow = editInfo => (data, setEditInfo, setData) => {
    const modData = data.map(d => {
      if (editInfo.updatedMap.get(d)) {
        return {
          ...editInfo.updatedMap.get(d),
          modificationInfo: undefined,
          updated: true,
          action: 'U',
        }
      } else {
        return d
      }
    })

    let editData = editInfo.updated
    editData = editData.map(d => ({
      ...d,
      modificationInfo: undefined,
    }))
    setEditInfo({ ...editInfo, updated: editData })
    setData(modData)
  }
  const getplantIdandEntityId = (cdate = selectedDate) => {
    const sel = storagePlantList.find(f => f.plantId === plantSelected)
    return {
      entityId: sel.entityId,
      entityid: sel.entityId,
      plantId: sel.plantId,
      plantid: sel.plantId,
      year: cdate.format('YYYY'),
      month: cdate.format('MM'),
    }
  }
  const getSelectedPlantDetails = useMemo(
    _ => {
      return storagePlantList.find(f => f.plantId === plantSelected) || {}
    },
    [plantSelected, storagePlantList]
  )
  const updateData = _ => {
    const saveData = freeEditEngine.applyEdits({
      data: storageInverterEventData.filter(d => d.updated),
      storageInverterEventEditInfo,
    })

    if (saveData.length <= 0) {
      message.error('Please, update data')
      return
    }

    setSpinning(true)

    solarStorageInvEventUpdateInverter(targetInfo)(saveData).fork(
      setError,
      errorList => {
        setSpinning(false)
        if (errorList.length > 0) setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data updated.')
          setStorageInverterEventEditInfo(
            freeEditEngine.generateInitialEditInfo()
          )
          retrieveData()
        }
      }
    )
  }

  const retrieveData = (dataChanged, cdate = selectedDate) => {
    if (dataChanged && storageInverterEventEditInfo.updated.length > 0) {
      setShowValidationDialog({
        visible: true,
        //  value: value, // passing the value to the modal
        onYes: updateData, // function to call when "Yes" is clicked
        onNo: retrieveData, // correctly passing value to onNo handler
      })
    } else {
      if (!plantSelected) {
        message.info('Please, Select Plant')
        return
      }
      setSpinning(true)
      getSolarStorageData(targetInfo)(getplantIdandEntityId(cdate)).fork(
        setError,
        data => {
          setSpinning(false)
          setIsRetrieved(true)

          const {
            storageInverterEvent,
            storageInverterPerformance,
            storageNercPerformance,
            jcTmpError = [],
          } = data
          setStorageInverterEventData(storageInverterEvent)
          setTmpError(jcTmpError)

          const inverterPerformanceData = R.sortBy((a, b) => {
            if ((a.inverterGroupName || '') === 'TOTAL') return 100000
            else {
              return R.toLower((a && a.inverterGroupName) || '').localeCompare(
                R.toLower((b && b.inverterGroupName) || '')
              )
            }
          }, storageInverterPerformance)

          setStorageInverterPerformanceData(inverterPerformanceData)
          // setTmpError(data.level2ValidationError)
          const storageNercPerformanceData = R.compose(
            R.sortBy((a, b) => {
              if ((a.inverterGroupName || '') === 'TOTAL') return 100000
              else {
                return R.toLower((a && a.inverterGroupId) || '').localeCompare(
                  R.toLower((b && b.inverterGroupId) || '')
                )
              }
            })
            // R.filter(f => f.inverterGroupName !== 'TOTAL')
          )(storageNercPerformance)

          setNercStoragePerformanceData(storageNercPerformanceData)
        }
      )
    }
  }
  const updateStorageNercPerformanceCall = _ => {
    const isTtoal =
      storageNercPerformanceRowSelected[0] &&
      (storageNercPerformanceRowSelected[0].subgroupName === 'TOTAL' ||
        storageNercPerformanceRowSelected[0].inverterGroupName === 'TOTAL')

    if (!isTtoal && !R.isNil(isTtoal) && !isPlantLocked)
      setStorageNercPerformanceDialog({
        isNew: false,
        visible: true,
        data: storageNercPerformanceRowSelected[0],
      })
  }

  const deleteStorageInverterEvent = _ => {
    setSpinning(true)
    solarStorageInvEventDeleteInverter(targetInfo)([
      storageInverterRowSelected[0],
    ]).fork(setError, errorList => {
      setSpinning(false)
      setTmpError(errorList)
      if (!isErrorContains(errorList)) {
        message.info('Data saved.')
        retrieveData()
      }
    })
  }

  const dateEditor = props => {
    const { data, header, rowIndex, style, getInputProps, cancelEdit } = props
    const { onChange, value } = getInputProps({ refKey: 'innerRef' })
    return (
      <DatePicker
        value={value ? moment(value) : null}
        showTime={{
          format: 'h:mm',
          defaultValue: moment('00:00', 'HH:mm'),
        }}
        onChange={date => {
          const newEditInfo = freeEditEngine.updateRow({
            storageInverterEventEditInfo,
            currentRow: data[rowIndex],
            editedRow: {
              ...data[rowIndex],
              [header.ident]: date ? date.format(header.dataFormat) : null,
            },
          })
          // setEditDataInfo(newEditInfo)
          editRow(newEditInfo)(
            storageInverterEventData,
            setStorageInverterEventEditInfo,
            setStorageInverterEventData
          )
          data[rowIndex][header.ident] = date
            ? date.format(header.dataFormat)
            : null
          onChange({
            target: { value: date ? date.format(header.dataFormat) : date },
          })
        }}
        style={{
          ...style,
          padding: `0px`,
          margin: `0px`,
          paddingLeft: `10px`,
          borderTop: `0px solid #fff`,
        }}
        format={header.displayFormat}
        size="small"
        onOpenChange={status => {
          if (!status) cancelEdit()
        }}
        allowClear={header.allowClear}
        suffixIcon={null}
        // bordered={false}
      />
    )
  }

  const storageInverterEventDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const type = gridToolProps.headers[reactVirtualizedProps.columnIndex].type

    if (headers[columnIndex].ident === 'eventId') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'eventId'),
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'

      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          // onDoubleClick={_ => {
          //   // onUpdate()
          //   !isPlantLocked && showInverterEventDilaog()
          // }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }

    return defaultVirtualizedCellRender({
      ...props,
      style,
      editRender:
        type === 'date' || type === 'date-time' ? dateEditor : undefined,
    })
  }

  const storageNercPerformanceDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps

    if (headers[columnIndex].ident === 'inverterGroupName') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'inverterGroupName') || {},
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'
      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          onDoubleClick={_ => {
            // onUpdate()
            !isPlantLocked && updateStorageNercPerformanceCall()
          }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }

    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        !isPlantLocked && updateStorageNercPerformanceCall()
      },
    })
  }

  const updateStorageInverterPerformanceCall = _ => {
    const isTtoal =
      storageInverterPerformanceRowSelected[0] &&
      (storageInverterPerformanceRowSelected[0].subgroupName === 'TOTAL' ||
        storageInverterPerformanceRowSelected[0].inverterGroupName === 'TOTAL')

    if (!isTtoal && !R.isNil(isTtoal) && !isPlantLocked)
      setShowStorageInverterPerformanceDialog({
        isNew: false,
        visible: true,
        data: storageInverterPerformanceRowSelected[0],
      })
  }

  const storageInverterPerformanceDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps

    if (headers[columnIndex].ident === 'inverterId') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'inverterId') || {},
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'
      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          onDoubleClick={_ => {
            // onUpdate()
            !isPlantLocked && updateStorageInverterPerformanceCall()
          }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }

    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        !isPlantLocked && updateStorageInverterPerformanceCall()
      },
    })
  }

  const isImpactIsSequence = useMemo(
    _ => {
      const mnt = moment()
        .startOf('month')
        .startOf('day')
      return !selectedDate
        .clone()
        .startOf('month')
        .startOf('day')
        .isAfter(mnt)
    },
    [selectedDate]
  )
  const [showRecalcCheckbox, setShowRecalcCheckbox] = useState(true)
  const [checkedValues, setCheckedValues] = useState(['E', 'P'])
  const [recalcInverterperf, setRecalcInverterPerf] = useState('N')
  const [impactAnalysisDialog, setImpactAnalysisDialog] = useState(false)
  const [impactAnalysisData, setImpactAnalysisData] = useState({})

  const impactAnalysisExecuteApi = createorprocess =>
    solarStorageImpactAnalysis(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
      mode: 'EXECUTE',
      createorprocess,
      recalcInverterperf,
    })

  const impactAnalysisApi = createorprocess =>
    solarStorageImpactAnalysis(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
      mode: 'ANALYZE',
      createorprocess,
      recalcInverterperf,
    })

  const callStorageImpactAnalysisExecuteApi = createorprocess => {
    setSpinning(true)
    impactAnalysisExecuteApi(createorprocess).fork(setError, data => {
      setSpinning(false)
      const { errors } = data
      // if (errors.length > 0) setTmpError(errors)
      if (!isErrorContains(errors)) {
        setTmpError(
          errors,
          _ => {
            message.info('Process Finished')
            if (errors.length <= 0) {
              setImpactAnalysisDialog(false)
              retrieveData()
            }
          },
          _ => {
            setImpactAnalysisDialog(false)
            retrieveData()
          }
        )
      } else {
        setTmpError(errors)
      }
    })
  }
  const callStorageImpactAnalysisApi = (mainCall, createorprocess) => {
    setSpinning(true)
    impactAnalysisApi(createorprocess).fork(setError, data => {
      setSpinning(false)

      const { impactSummary = [] } = data
      const isNotValidDAta = impactSummary.filter(
        f => f.tabId === '0' && f.impactYN === 'Y'
      )

      if (isNotValidDAta.length > 0) {
        setImpactAnalysisDialog(true)
        setImpactAnalysisData({ ...data, createorprocess })

        // mainCall()
      } else {
        message.info('All events and performance data are up to date.')
      }
    })
  }
  const CREATE = 'CREATE'
  const PROCESS = 'PROCESS'

  const callStorageCreateInverterEventData = _ => {
    setSpinning(true)
    createSolarStorageInvPerormanceWithInvEvents(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
    }).fork(setError, tmpError => {
      setSpinning(false)
      setTmpError(tmpError)
      if (!isErrorContains(tmpError)) {
        message.info('Process completed successfully.')
        retrieveData()
      }
    })
  }

  const createStorageInverterData = _ => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    if (isImpactIsSequence) {
      // message.info('Month is out of Sequence.')
      callStorageImpactAnalysisApi(callStorageCreateInverterEventData, CREATE)
    } else {
      callStorageCreateInverterEventData()
    }
  }

  const callProcessEventBoth = _ => {
    setSpinning(true)
    solarStorageProcessEventAndPerformanceData(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
      type:
        checkedValues.includes('P') && checkedValues.includes('E')
          ? 'A'
          : checkedValues[0],
    }).fork(setError, tmpError => {
      setSpinning(false)
      if (!isErrorContains(tmpError)) {
        message.info('Process finished.')
        retrieveData()
      }
      setTmpError(tmpError)
    })
  }

  const onStorageProcessEventsBoth = _ => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    if (checkedValues.length <= 0) {
      message.info('Please, Select Process Type')
      return
    }
    if (isImpactIsSequence) {
      // message.info('Month is out of Sequence.')
      callStorageImpactAnalysisApi(callProcessEventBoth, PROCESS)
    } else {
      // callProcessEventBoth()
    }
  }

  const JobSProcessInfo = ({ recalcInverterperf, setRecalcInverterPerf }) => {
    if (!hasSolarPowerDataWritePermission) return <div />

    return (
      <Content
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          gap: 5,
          marginTop: '10px',
          paddingBottom: '10px',
          paddingTop: '10px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns1: '100px 150px 200px 10px 200px',
            gridTemplateColumns: '200px auto',
            gridTemplateRows: 'auto auto auto',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <h3>Run Job</h3>
          </div>
          <div />
          <Button
            type="primary"
            onClick={createStorageInverterData}
            icon="database"
            style={{ width: '100%' }}
            disabled={!isImpactIsSequence || !(isRetrived && !isPlantLocked)}
          >
            Create All Data
          </Button>

          <div />
          <div style={{ gridColumnEnd: 'span 2' }}>
            This process will create Inverter level and NERC level Events and
            Performance Data. All existing manually edited data will be
            replaced. An impact analysis will be presented before executing.
          </div>
        </div>
        <Divider type="vertical" style={{ height: '100%' }} />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '200px 210px auto',
            gap: '5px',
          }}
        >
          <div
            style={{
              gridRowEnd: 'span 1',
              display: 'grid',
              justifyItems: 'center',
              alignContent: 'baseline',
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <h3>Recreate NERC Data</h3>
            </div>
            <Button
              type="primary"
              onClick={onStorageProcessEventsBoth}
              // disabled={!isImpactIsSequence}
              disabled={!isImpactIsSequence || !(isRetrived && !isPlantLocked)}
              icon="database"
            >
              Process All Data
            </Button>
          </div>
          {showRecalcCheckbox && (
            <div>
              <div style={{ height: '30px' }} />
              <Tooltip title="When selected process will update the inverter level performance data based on inverter events.">
                <Checkbox
                  style={{ padding: '5px 0px' }}
                  checked={recalcInverterperf === 'Y'}
                  onChange={e =>
                    setRecalcInverterPerf(e.target.checked ? 'Y' : 'N')
                  }
                  disabled={
                    !isImpactIsSequence || !(isRetrived && !isPlantLocked)
                  }
                >
                  Recalc Inverter Performance
                </Checkbox>
              </Tooltip>
            </div>
          )}

          <div style={{ gridColumnEnd: 'span 3' }}>
            This process will regenerate NERC Event and Performance Data using
            existing Inverter level data, including manually edited records. An
            impact analysis will be presented before executing.
          </div>
        </div>
      </Content>
    )
  }

  return (
    <div>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '300px 250px 200px 150px auto auto auto',
            gap: '10px',
            width: '100%',
          }}
        >
          <Title>
            {isStandalone
              ? 'Solar Standalone Storage Data'
              : 'Solar Storage Data'}
          </Title>
          <Select
            showSearch
            value={plantSelected}
            style={{ width: '100%' }}
            onChange={plantId => {
              setPlantSelected(plantId)
              clearData()
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {storagePlantList.map(({ plantId, plantName }) => (
              <Select.Option key={plantId} value={plantId}>
                {plantName}
              </Select.Option>
            ))}
          </Select>
          <DatePicker.MonthPicker
            allowClear={false}
            style={{ width: '100%' }}
            format="MMMM-YYYY"
            value={selectedDate}
            onChange={d => {
              setSelectedDate(d.endOf('month'))
              clearData()
            }}
          />

          <Button.Group style={{ minWidth: '130px', marginLeft: '10px' }}>
            <Button
              title="Previous Month"
              style={{ marginLeft: '10px' }}
              type="primary"
              onClick={() => {
                clearData()
                const dt = selectedDate
                  .clone()
                  .subtract(1, 'M')
                  .endOf('month')
                setSelectedDate(dt)
                retrieveData(true, dt)
              }}
            >
              <Icon type="left" />
            </Button>

            <Button
              title="Next Month"
              style={{}}
              type="primary"
              onClick={() => {
                clearData()
                const dt = selectedDate
                  .clone()
                  .add(1, 'M')
                  .endOf('month')
                setSelectedDate(dt)
                retrieveData(true, dt)
              }}
            >
              <Icon type="right" />
            </Button>
          </Button.Group>
          <Button
            type="primary"
            onClick={() => retrieveData(true)}
            icon="database"
            style={{ width: '150px' }}
          >
            Retrieve
          </Button>
          <Filler />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
            {isRetrived && (
              <div style={{ display: 'flex' }}>
                <Label>
                  <b>Plant Status : </b>
                </Label>
                <Icon
                  type={isPlantLocked ? 'lock' : 'unlock'}
                  style={{
                    fontSize: '30px',
                  }}
                  theme="twoTone"
                />
              </div>
            )}
          </div>
        </div>
        <Filler />
      </CriteriaRow>

      <JobSProcessInfo
        recalcInverterperf={recalcInverterperf}
        setRecalcInverterPerf={setRecalcInverterPerf}
      />

      <FullHeightSizer
        heightOffset={hasSolarPowerDataWritePermission ? 350 : 220}
        // heightOffset={200}
        widthOffset={20}
      >
        {({ height, width }) => (
          <Content style={{ padding: '10px', height, width }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: width - 200 + 'px',
                gap: '10px',
              }}
            >
              <div
                style={{
                  gap: '15px',
                  display: 'grid',
                  gridTemplateColumns:
                    '450px auto 450px auto 250px 150px 150px 150px 150px',
                  paddingRight: '40px',
                  alignItems: 'baseline',
                  // alignContent: 'center',
                  gridColumnEnd: 'span 2',
                  // justifyContent: 'end',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'max-content 300px',
                    gap: '5px',
                  }}
                >
                  <Label>Select : </Label>
                  <Select
                    showSearch
                    onChange={value => handleIsPerformacneSelected(value)}
                    value={isPerformacneSelected}
                    width={300}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Select.Option value="SNP">
                      Storage NERC Performance
                    </Select.Option>
                    <Select.Option value="SIP">
                      Storage Inverter Performance
                    </Select.Option>
                    <Select.Option value="SIE">
                      Storage Inverter Events
                    </Select.Option>
                  </Select>
                </div>
                <div />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '10px 90px 50px 150px 50px 10px',
                    justifyContent: 'center',
                    gap: '5px',
                    borderLeft: '0px solid gray',
                    borderRight: '0px solid gray',
                  }}
                >
                  <Divider
                    type="vertical"
                    style={{ height: '100%', backgroundColor: '#8080807a' }}
                  />
                  <div style={{ textAlign: 'end' }}>Automated</div>
                  <div
                    style={{
                      backgroundColor: '#c5e0b4',
                      border: '0px solid black',
                      textAlign: 'center',
                      fontWeight: '700',
                      color: '#c5e0b4',
                      height: '70%',
                      alignSelf: 'center',
                    }}
                  />
                  <div style={{ textAlign: 'end' }}>Manually Update</div>
                  <div
                    style={{
                      backgroundColor: '#ffff00',
                      border: '0px solid black',
                      textAlign: 'center',
                      fontWeight: '700',
                      color: '#ffff00',
                      height: '70%',
                      alignSelf: 'center',
                    }}
                  />
                  <Divider
                    type="vertical"
                    style={{ height: '100%', backgroundColor: '#8080807a' }}
                  />
                </div>
                <div />
                <Input.Search
                  placeholder="Filter"
                  value={fuzzyFilter}
                  style={{
                    gridColumnEnd: 'span 1',
                  }}
                  onChange={e => setFuzzyFilter(e.target.value)}
                />

                {isPerformacneSelected === 'SIP' && (
                  <React.Fragment>
                    <Button
                      key="2"
                      style={{ width: '150px', paddingRight: '10px' }}
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          storageInverterPerformanceRowSelected.length > 0
                        )
                      }
                      onClick={updateStorageInverterPerformanceCall}
                      type="primary"
                    >
                      {hasSolarPowerDataWritePermission ? 'Update' : 'View'}
                    </Button>
                  </React.Fragment>
                )}

                {isPerformacneSelected === 'SNP' && [
                  <Button
                    key="2"
                    style={{ width: '150px', paddingRight: '10px' }}
                    disabled={
                      !(
                        isRetrived &&
                        !isPlantLocked &&
                        storageNercPerformanceRowSelected.length > 0
                      )
                    }
                    onClick={updateStorageNercPerformanceCall}
                    type="primary"
                  >
                    {hasSolarPowerDataWritePermission ? 'Update' : 'View'}
                  </Button>,
                ]}

                {isPerformacneSelected === 'SIE' && (
                  <React.Fragment>
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        disabled={!(isRetrived && !isPlantLocked)}
                        type="primary"
                        onClick={_ => {
                          setStorageInverterEventDialog({
                            isNew: true,
                            visible: true,
                            data: {
                              ...getplantIdandEntityId(),
                              action: 'A',
                              eventtype: 'FO',
                              eventstart: selectedDate
                                .clone()
                                .startOf('month')
                                .format(saveDateformat),
                              eventstartTimeZone: getTimeZone({
                                pzone: getSelectedPlantDetails.timeZone,
                                daylightSavings:
                                  getSelectedPlantDetails.daylightSaving,
                                date: selectedDate
                                  .clone()
                                  .startOf('month')
                                  .format(saveDateformat),
                                sortOrder: 'asc',
                              }),
                            },
                          })
                        }}
                      >
                        Add
                      </Button>
                    )}
                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          storageInverterRowSelected.length > 0
                        )
                      }
                      onClick={_ => {
                        setStorageInverterEventDialog({
                          isNew: false,
                          visible: true,
                          data: {
                            eventtype: 'FO',
                            ...storageInverterRowSelected[0],
                            ...getplantIdandEntityId(),
                            action: 'U',
                          },
                        })
                      }}
                      type="primary"
                    >
                      {hasSolarPowerDataWritePermission ? 'Update' : 'View'}
                    </Button>
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            !isPlantLocked &&
                            !storageInverterEventEditInfo.updated.length <= 0
                          )
                        }
                        onClick={updateData}
                        type="primary"
                      >
                        Save
                      </Button>
                    )}
                    {hasSolarPowerDataWritePermission && (
                      <Popconfirm
                        title="Delete the task ?"
                        description="Are you sure to delete this task?"
                        onConfirm={deleteStorageInverterEvent}
                        onCancel={_ => _}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          disabled={
                            !(
                              isRetrived &&
                              !isPlantLocked &&
                              storageInverterRowSelected.length > 0
                            )
                          }
                          type="danger"
                          style={{ width: '100%' }}
                        >
                          Delete
                        </Button>
                      </Popconfirm>
                    )}
                  </React.Fragment>
                )}
              </div>

              {isPerformacneSelected === 'SIP' && (
                <div style={{ gridColumnEnd: 'span 1', height: height }}>
                  <Grid
                    sortEnabled
                    data={storageInverterPerformanceData}
                    headers={StorageInverterPerformanceHeaderFormater}
                    altBy={u => u.subgroupName}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 70,
                      width: width - 30,
                      headerRowHeight: 30,
                      cellRender: storageInverterPerformanceDoubleClick,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      if (
                        selectedRows[0] &&
                        (selectedRows[0].subgroupName === 'TOTAL' ||
                          selectedRows[0].inverterGroupName === 'TOTAL')
                      )
                        setStorageInverterPerformanceRowSelected([])
                      else
                        setStorageInverterPerformanceRowSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    initialSortOptions={
                      StorageInverterPerformanceHeaderFormater
                    }
                  />
                </div>
              )}
              {isPerformacneSelected === 'SNP' && (
                <div style={{ gridColumnEnd: 'span 1', height: height }}>
                  <Grid
                    sortEnabled
                    data={storageNercPerformanceData}
                    headers={StorageNercPerformanceHeaderFormater}
                    altBy={u => u.subgroupName}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 70,
                      width: width - 30,
                      headerRowHeight: 30,
                      cellRender: storageNercPerformanceDoubleClick,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      if (
                        selectedRows[0] &&
                        (selectedRows[0].subgroupName === 'TOTAL' ||
                          selectedRows[0].inverterGroupName === 'TOTAL')
                      )
                        setStorageNercPerformanceRowSelected([])
                      else setStorageNercPerformanceRowSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    initialSortOptions={StorageNercPerformanceHeaderFormater}
                  />
                </div>
              )}
              {isPerformacneSelected === 'SIE' && (
                <div style={{ height: height }}>
                  <Grid
                    data={storageInverterEventData}
                    headers={StorageInverterEventHeaders(width - 30)}
                    altBy={u => u.entityId}
                    altBgColor="#ebebeb"
                    onEditInfoChange={info =>
                      editRow(info)(
                        storageInverterEventData,
                        setStorageInverterEventEditInfo,
                        setStorageInverterEventData
                      )
                    }
                    editInfo={storageInverterEventEditInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 70,
                      width: width - 30,
                      headerRowHeight: 30,
                      cellRender: storageInverterEventDoubleClick,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    isEditable={!isPlantLocked && isEditableComp}
                    onSelectionChange={({ selectedRows }) => {
                      setStorageInverterRowSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    editMode="cell"
                    // initialSortOptions={StorageInverterEventHeaders(width - 30)}
                  />
                </div>
              )}
            </div>
          </Content>
        )}
      </FullHeightSizer>

      {showValidationDialog.visible && (
        <SolarInverterValidationDialog
          {...showValidationDialog}
          // visible
          onHide={_ => {
            setShowValidationDialog({})
          }}
          onRevertData={() => {
            setShowValidationDialog({})
            setStorageInverterEventEditInfo(
              freeEditEngine.generateInitialEditInfo()
            )
          }}
        />
      )}

      {showStorageNercPerformanceDialog.visible && (
        <SolarStoragePerformanceDialog
          {...showStorageNercPerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setStorageNercPerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          availableStatus={availableStatus}
          setTmpError={setTmpError}
          isStorageDialog
        />
      )}
      {showStorageInverterPerformanceDialog.visible && (
        <SolarStorageInverterPerformanceDialog
          {...showStorageInverterPerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setShowStorageInverterPerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          availableStatus={availableStatus}
          setTmpError={setTmpError}
          inverterIdBYPlant={inverterIdBYPlant}
          isStorageDialog
        />
      )}
      {showStorageInverterEventDialog.visible && (
        <SolarInverterEventDialog
          {...showStorageInverterEventDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setStorageInverterEventDialog({})
          }}
          onRetrieve={retrieveData}
          unitCodeMap={['SO']}
          contribConditionList={contribConditionList}
          causeCodeList={causecodeList}
          selectedPlantDetails={getSelectedPlantDetails}
          inverterIdBYPlant={inverterIdBYPlant.filter(
            f => f.plantId === plantSelected
          )}
          storageGroupNameMap={storageGroupNameMap}
          selectedDate={selectedDate.clone().startOf('d')}
          eventTypes={eventTypes}
          isStorageDialog
        />
      )}

      {impactAnalysisDialog && (
        <ImpactAnalysisModal
          targetInfo={targetInfo}
          data={impactAnalysisData}
          createorprocess={impactAnalysisData.createorprocess}
          onClose={_ => setImpactAnalysisDialog(false)}
          visible={impactAnalysisDialog}
          setSpinning={setSpinning}
          spinning={spinning}
          request={{
            year: selectedDate.format('YYYY'),
            month: selectedDate.format('MM'),
            plantid: plantSelected,
            mode: 'ANALYZE',
            plantName: (
              storagePlantList.find(f => f.plantId === plantSelected) || {}
            ).plantName,
          }}
          setError={setError}
          setImpactAnalysisData={setImpactAnalysisData}
          callImpactAnalysisExecuteApi={callStorageImpactAnalysisExecuteApi}
          impactAnalysisApi={impactAnalysisApi}
          retrieveData={retrieveData}
          setTmpError={setTmpError}
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
})
export default connect(mapStateToProps)(StoragePowerData)

const SolarStoragePerformanceIoHeaders = [
  // strCol({
  //   ident: 'entityId',
  //   display: 'NCR ID/NERC ID',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  //   width: 200,
  //   ellipsis: true,
  // }),
  // strCol({
  //   ident: 'plantId',
  //   display: 'Plant ID',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  //   width: 200,
  //   ellipsis: true,
  // }),
  strCol({
    ident: 'storageGroupId',
    display: 'Storage Group Id',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
    ellipsis: true,
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'storageGroupAvailability',
    display: 'Availability Status',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'chargeMwh',
    display: 'Charge MWh',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'dischargeMwh',
    display: 'Discharge MWh',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'chargeHrs',
    display: 'Charge Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'dischargeHrs',
    display: 'Discharge Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'foHrs',
    display: 'FO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'moHrs',
    display: 'MO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'poHrs',
    display: 'PO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]
